// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"53":"4b7c65ef","83":"1c1e8643","221":"09280a02","314":"8f2e2b17","326":"72e33c86","350":"fef8086a","414":"badb7241","771":"52fc8897","793":"8d12670e","835":"072e8382","842":"b5e8f161"}[chunkId] + ".chunk.css";
};